import * as keyset from 'i18n/DraftControlPanel';
import i18n from '@yandex-int/i18n';
import { DraftStatus, DraftStatusSmartHome } from '../../model/draft';
import { Channel } from '../../model/skill';

const t = i18n(keyset);

type TextSet<TStatus extends string> = Record<TStatus, string>;

const aliceSkillDescriptions: TextSet<DraftStatus> = {
    [DraftStatus.InDevelopment]: t('desc-in-dev'),
    [DraftStatus.ReviewRequested]: t('desc-in-review'),
    [DraftStatus.ReviewApproved]: t('desc-approved'),
    [DraftStatus.DeployRequested]: t('desc-deploy'),
};

const tvAppDescriptions: TextSet<DraftStatus> = {
    [DraftStatus.InDevelopment]: t('desc-in-dev'),
    [DraftStatus.ReviewRequested]: t('desc-in-review'),
    [DraftStatus.ReviewApproved]: t('desc-approved'),
    [DraftStatus.DeployRequested]: t('desc-deploy'),
};

const smartHomeDescriptions: TextSet<DraftStatusSmartHome> = {
    [DraftStatusSmartHome.InDevelopment]: t('sh-desc-in-dev'),
    [DraftStatusSmartHome.ReviewRequested]: t('sh-desc-in-review'),
    [DraftStatusSmartHome.MeetingApproval]: t('sh-desc-meeting'),
    [DraftStatusSmartHome.WaitingForTesting]: t('sh-desc-waiting-for-test'),
    [DraftStatusSmartHome.DevicesTesting]: t('sh-desc-devices-testing'),
    [DraftStatusSmartHome.DevicesTestingCompleted]: t('sh-desc-testing-complete'),
    [DraftStatusSmartHome.ReviewApproved]: t('sh-desc-approved'),
    [DraftStatusSmartHome.DeployRequested]: t('desc-deploy'),
};

const thereminvoxDescriptions: TextSet<DraftStatus> = {
    [DraftStatus.InDevelopment]: t('desc-in-dev'),
    [DraftStatus.ReviewRequested]: t('desc-in-review'),
    [DraftStatus.ReviewApproved]: t('desc-approved'),
    [DraftStatus.DeployRequested]: t('desc-deploy'),
};

export const skillDescriptions = {
    [Channel.AliceSkill]: aliceSkillDescriptions,
    [Channel.SmartHome]: smartHomeDescriptions,
    [Channel.Thereminvox]: thereminvoxDescriptions,
    [Channel.TvApp]: tvAppDescriptions,
};

const aliceSkillDescriptionsAired: TextSet<DraftStatus> = {
    [DraftStatus.InDevelopment]: t('desc-in-dev'),
    [DraftStatus.ReviewRequested]: t('desc-in-review'),
    [DraftStatus.ReviewApproved]: t('desc-approved'),
    [DraftStatus.DeployRequested]: t('aired-deploy'),
};

const tvAppDescriptionsAired: TextSet<DraftStatus> = {
    [DraftStatus.InDevelopment]: t('desc-in-dev'),
    [DraftStatus.ReviewRequested]: t('desc-in-review'),
    [DraftStatus.ReviewApproved]: t('desc-approved'),
    [DraftStatus.DeployRequested]: t('aired-deploy'),
};

const smartHomeDescriptionsAired: TextSet<DraftStatusSmartHome> = {
    [DraftStatusSmartHome.InDevelopment]: t('sh-desc-in-dev'),
    [DraftStatusSmartHome.ReviewRequested]: t('sh-desc-in-review'),
    [DraftStatusSmartHome.MeetingApproval]: t('sh-desc-meeting'),
    [DraftStatusSmartHome.WaitingForTesting]: t('sh-desc-waiting-for-test'),
    [DraftStatusSmartHome.DevicesTesting]: t('sh-desc-devices-testing'),
    [DraftStatusSmartHome.DevicesTestingCompleted]: t('sh-desc-testing-complete'),
    [DraftStatusSmartHome.ReviewApproved]: t('sh-desc-approved'),
    [DraftStatusSmartHome.DeployRequested]: t('desc-deploy'),
};

const thereminvoxDescriptionsAired: TextSet<DraftStatus> = {
    [DraftStatus.InDevelopment]: t('desc-in-dev'),
    [DraftStatus.ReviewRequested]: t('desc-in-review'),
    [DraftStatus.ReviewApproved]: t('desc-approved'),
    [DraftStatus.DeployRequested]: t('aired-deploy'),
};

export const skillDescriptionsAired = {
    [Channel.AliceSkill]: aliceSkillDescriptionsAired,
    [Channel.SmartHome]: smartHomeDescriptionsAired,
    [Channel.Thereminvox]: thereminvoxDescriptionsAired,
    [Channel.TvApp]: tvAppDescriptionsAired,
};
